var _defs, _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2049 1152",
    width: 2049,
    height: 1152,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m696.46-200.43h2325v1550h-2325z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff}.b{fill:#ebebeb}.c{fill:#dfdfdf}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1024 767.3c-147.5 0-266.6-119.2-266.6-266.6 0-147.5 119.1-266.6 266.6-266.6 147.4 0 266.6 119.1 266.6 266.6 0 147.4-119.2 266.6-266.6 266.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1038 694.7c-27.3 0-49.3-22-49.3-49.2 0-27.3 22-49.3 49.3-49.3 27.2 0 49.2 22 49.2 49.3 0 27.2-22 49.2-49.2 49.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m1001.9 678.9c-8.2-8.8-13.2-20.5-13.2-33.4 0-27.3 22.1-49.3 49.3-49.3 16.4 0 30.9 8 39.8 20.4-9-9.7-21.8-15.8-36.1-15.8-27.2 0-49.2 22-49.2 49.2 0 10.8 3.5 20.8 9.4 28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m867.9 521.1c-37.6 0-67.9-30.3-67.9-67.9 0-37.6 30.3-68 67.9-68 37.6 0 68 30.4 68 68 0 37.6-30.4 67.9-68 67.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m818.1 499.3c-11.2-12.1-18.1-28.3-18.1-46.1 0-37.5 30.4-68 67.9-68 22.7 0 42.7 11.2 55 28.2-12.4-13.4-30.1-21.8-49.8-21.8-37.5 0-67.9 30.4-67.9 67.9 0 14.9 4.8 28.6 12.9 39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1162.8 387.6c-16 0-28.9-12.9-28.9-28.9 0-15.9 12.9-28.9 28.9-28.9 15.9 0 28.9 13 28.9 28.9 0 16-13 28.9-28.9 28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m1141.6 378.4c-4.8-5.2-7.7-12.1-7.7-19.7 0-15.9 12.9-28.9 28.9-28.9 9.6 0 18.1 4.8 23.3 12-5.2-5.7-12.7-9.3-21.1-9.3-16 0-28.9 13-28.9 28.9 0 6.4 2 12.2 5.5 17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m996.2 339.7c-19.9 0-35.9-16.1-35.9-35.9 0-19.9 16-36 35.9-36 19.8 0 35.9 16.1 35.9 36 0 19.8-16.1 35.9-35.9 35.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m969.9 328.1c-6-6.4-9.6-14.9-9.6-24.3 0-19.9 16.1-36 35.9-36 11.9 0 22.5 5.9 29 14.9-6.5-7.1-15.9-11.5-26.3-11.5-19.8 0-35.9 16.1-35.9 35.9 0 7.9 2.6 15.1 6.9 21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1048.9 293.7c-9.3 0-16.8-7.5-16.8-16.8 0-9.3 7.5-16.8 16.8-16.8 9.3 0 16.8 7.5 16.8 16.8 0 9.3-7.5 16.8-16.8 16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m1036.6 288.3c-2.8-3-4.5-7-4.5-11.4 0-9.3 7.5-16.8 16.8-16.8 5.6 0 10.5 2.7 13.6 6.9-3.1-3.3-7.5-5.3-12.3-5.3-9.3 0-16.8 7.5-16.8 16.8 0 3.6 1.2 7 3.2 9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m783.2 517.5c-9.3 0-16.8-7.5-16.8-16.8 0-9.3 7.5-16.8 16.8-16.8 9.3 0 16.8 7.5 16.8 16.8 0 9.3-7.5 16.8-16.8 16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m770.9 512.1c-2.8-3-4.5-7-4.5-11.4 0-9.3 7.5-16.8 16.8-16.8 5.6 0 10.5 2.7 13.6 6.9-3.1-3.3-7.5-5.4-12.3-5.4-9.3 0-16.8 7.6-16.8 16.8 0 3.7 1.2 7.1 3.2 9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m876.6 378.4c-4.6 0-8.4-3.8-8.4-8.4 0-4.7 3.8-8.4 8.4-8.4 4.7 0 8.4 3.7 8.4 8.4 0 4.6-3.7 8.4-8.4 8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m870.5 375.7c-1.4-1.5-2.3-3.5-2.3-5.7 0-4.7 3.8-8.4 8.4-8.4 2.8 0 5.3 1.3 6.8 3.4-1.5-1.6-3.7-2.6-6.1-2.6-4.7 0-8.4 3.7-8.4 8.3 0 1.9 0.6 3.6 1.6 5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m817.7 534.3c-4.6 0-8.4-3.8-8.4-8.4 0-4.7 3.8-8.4 8.4-8.4 4.6 0 8.4 3.7 8.4 8.4 0 4.6-3.8 8.4-8.4 8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m811.5 531.6c-1.3-1.5-2.2-3.5-2.2-5.7 0-4.7 3.8-8.4 8.4-8.4 2.8 0 5.3 1.3 6.8 3.4-1.5-1.6-3.7-2.7-6.2-2.7-4.6 0-8.4 3.8-8.4 8.4 0 1.9 0.6 3.6 1.6 5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1104.2 639.4c-4.7 0-8.4-3.7-8.4-8.4 0-4.6 3.7-8.3 8.4-8.3 4.6 0 8.4 3.7 8.4 8.3 0 4.7-3.8 8.4-8.4 8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m1098 636.8c-1.4-1.5-2.2-3.5-2.2-5.8 0-4.6 3.7-8.3 8.4-8.3 2.8 0 5.2 1.3 6.8 3.4-1.6-1.6-3.8-2.7-6.2-2.7-4.6 0-8.4 3.8-8.4 8.4 0 1.9 0.6 3.6 1.6 5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1160 408c-4.6 0-8.4-3.8-8.4-8.4 0-4.7 3.8-8.4 8.4-8.4 4.7 0 8.4 3.7 8.4 8.4 0 4.6-3.7 8.4-8.4 8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m1153.9 405.3c-1.4-1.5-2.3-3.5-2.3-5.7 0-4.7 3.8-8.4 8.4-8.4 2.8 0 5.3 1.3 6.8 3.4-1.5-1.6-3.7-2.7-6.1-2.7-4.7 0-8.4 3.8-8.4 8.4 0 1.9 0.6 3.6 1.6 5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1241.6 476.5c-9.3 0-16.8-7.5-16.8-16.8 0-9.3 7.5-16.8 16.8-16.8 9.3 0 16.8 7.5 16.8 16.8 0 9.3-7.5 16.8-16.8 16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m1229.3 471.1c-2.8-3-4.5-7-4.5-11.4 0-9.3 7.5-16.8 16.8-16.8 5.6 0 10.5 2.7 13.6 6.9-3.1-3.3-7.5-5.4-12.3-5.4-9.3 0-16.8 7.6-16.8 16.8 0 3.7 1.2 7.1 3.2 9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1133.9 717.6c-9.3 0-16.8-7.5-16.8-16.8 0-9.2 7.5-16.7 16.8-16.7 9.3 0 16.8 7.5 16.8 16.7 0 9.3-7.5 16.8-16.8 16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m1121.6 712.3c-2.8-3-4.5-7-4.5-11.5 0-9.2 7.5-16.7 16.8-16.7 5.6 0 10.5 2.7 13.6 6.9-3.1-3.3-7.5-5.4-12.3-5.4-9.3 0-16.8 7.5-16.8 16.8 0 3.7 1.2 7.1 3.2 9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m1106.7 611.8c-15 0-27.1-12.1-27.1-27.1 0-15 12.1-27.1 27.1-27.1 15 0 27.2 12.1 27.2 27.1 0 15-12.2 27.1-27.2 27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m1086.9 603.1c-4.5-4.8-7.3-11.3-7.3-18.4 0-15 12.2-27.1 27.1-27.1 9.1 0 17.1 4.4 22 11.2-5-5.4-12-8.7-19.9-8.7-15 0-27.1 12.1-27.1 27.1 0 5.9 1.9 11.4 5.2 15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m939.5 684.1c-15 0-27.1-12.2-27.1-27.2 0-15 12.1-27.1 27.1-27.1 15 0 27.1 12.1 27.1 27.1 0 15-12.1 27.2-27.1 27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m919.6 675.4c-4.5-4.9-7.2-11.3-7.2-18.5 0-14.9 12.1-27.1 27.1-27.1 9 0 17 4.4 21.9 11.2-4.9-5.3-12-8.7-19.8-8.7-15 0-27.2 12.2-27.2 27.2 0 5.9 2 11.4 5.2 15.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.aacb7bf529f7d74d99c29355b209c4d1.svg";
export { ForwardRef as ReactComponent };